import React from 'react';
import classNames from 'classnames';
import ribbon from '../../assets/images/time-best-inventions-2026.webp';
import styles from './TimeAwardRibbon.module.scss';

/**
 * Ultra's TIME Best Inventions 2026 ribbon. Sizes itself; the parent places it (absolutely, from a
 * relative title block) so it hangs beside the name without pushing the copy around.
 */
export default function TimeAwardRibbon({ className }: { className?: string }) {
  return (
    <img
      src={ribbon}
      // the award's own name, the same in every locale
      alt="TIME Best Inventions 2026"
      width={300}
      height={422}
      className={classNames(styles.ribbon, className)}
    />
  );
}
